<template>
    <div class="container-outline">
        <div class="register">
            <div class="title-page">Register</div>
            <div class="top-squence">
                <head-register :dataSquence="{ id: 12, title: 'kode akses' }"></head-register>
            </div>
            <div class="content-register">
                <div class="container">
                    <div class="wrap-content">
                        <div class="">
                            <p class="title">VERIFIKASI KELENGKAPAN PROSES PENERIMAAN NASABAH SECARA ELEKTRONIK ONLINE</p>
                            <div class="content">
                                <div class="content-item">
                                    <div>PROFIL PERUSAHAAN PIALANG BERJANGKA</div>
                                    <div>
                                        <span v-if="form.has_set_company_profile">Complete</span>
                                        <span v-else>Incomplete</span>
                                    </div>
                                </div>
                                <div class="content-item">
                                    <div>PERNYATAAN TELAH MELAKUKAN SIMULASI PERDAGANGAN BERJANGKA</div>
                                    <div>
                                        <span v-if="form.has_set_trading_simulation">Complete</span>
                                        <span v-else>Incomplete</span>
                                    </div>
                                </div>
                                <div class="content-item">
                                    <div>PERNYATAAN PENGUNGKAPAN (DISCLOSURE STATEMENT)</div>
                                    <div>
                                        <span v-if="form.disclosure_customer">Complete</span>
                                        <span v-else>Incomplete</span>
                                    </div>
                                </div>
                                <div class="content-item">
                                    <div>APLIKASI PEMBUKAAN REKENING TRANSAKSI</div>
                                    <div>
                                        <span v-if="form.has_confirm_costumer">Complete</span>
                                        <span v-else>Incomplete</span>
                                    </div>
                                </div>
                                <div class="content-item">
                                    <div>DOKUMEN PEMBERITAHUAN ADANYA RISIKO</div>
                                    <div>
                                        <span v-if="form.has_set_risk">Complete</span>
                                        <span v-else>Incomplete</span>
                                    </div>
                                </div>
                                <div class="content-item">
                                    <div>PERJANJIAN PEMBERIAN AMANAT</div>
                                    <div>
                                        <span v-if="form.has_set_mandate">Complete</span>
                                        <span v-else>Incomplete</span>
                                    </div>
                                </div>
                                <div class="content-item">
                                    <div>PERATURAN PERDAGANGAN (TRADING RULES)</div>
                                    <div>
                                        <span v-if="form.has_set_trading_rules">Complete</span>
                                        <span v-else>Incomplete</span>
                                    </div>
                                </div>
                                <div class="content-item">
                                    <div>KODE AKSES TRANSAKSI NASABAH (Personal Access Password)</div>
                                    <div>
                                        <span v-if="form.has_set_trading_rules">Complete</span>
                                        <span v-else>Incomplete</span>
                                    </div>
                                </div>
                                <div class="content-item">
                                    <div>PERNYATAAN BAHWA DANA YANG DIGUNAKAN SEBAGAI MARGIN MERUPAKAN DANA MILIK NASABAH SENDIRI</div>
                                    <div>
                                        <span v-if="form.has_set_trading_rules">Complete</span>
                                        <span v-else>Incomplete</span>
                                    </div>
                                </div>
                            </div>

                            <div class="penutup">
                                <div class="content-penutup">
                                    Dengan mengisi kolom “YA” di bawah ini, saya menyatakan bahwa saya telah membaca dan memahami seluruh isi dokumen yang
                                    disampaikan dalam form pembukaan rekening
                                </div>
                                <div class="content-penutup">
                                    Demikian Pernyataan ini dibuat dengan sebenarnya dalam keadaan sadar, sehat jasmani dan rohani serta tanpa paksaan apapun dari
                                    pihak manapun.
                                </div>

                                <div class="wrap-pernyataan">
                                    <div class="pernyataan">
                                        <div class="label">Pernyataan Menerima / Tidak</div>
                                        <div class="wrap-radio-input">
                                            <div class="radio-input">
                                                <input type="radio" name="radios" id="1" :value="true" v-model="form.completeness_verification" required />
                                                <label class="label-radio" for="">
                                                    Ya
                                                </label>
                                            </div>
                                            <div class="radio-input">
                                                <input type="radio" name="radios" id="2" :value="false" v-model="form.completeness_verification" /><label
                                                    class="label-radio"
                                                    for=""
                                                    >Tidak</label
                                                >
                                            </div>
                                        </div>
                                    </div>
                                    <div class="pernyataan">
                                        <div class="label">Pernyataan Pada Tanggal</div>
                                        <div>
                                            {{ currentDate | formatDateTime }}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <disclosure-statement :disclosureValue="disclosure_completeness" @updateValue="checkStatement"></disclosure-statement>

                    <div class="button">
                        <router-link to="/register-preview"><button class="btn-scondary">Sebelumnya</button></router-link>
                        <button class="btn-primer" type="submit" @click="registerKyc">
                            <div v-show="loading == false">Submit</div>
                            <b-spinner variant="light" v-show="loading" />
                        </button>
                    </div>

                    <b-modal ref="modal-statement" title="Pernyataan">
                        <h5 class="text-center">Dengan ini saya menyatakan bahwa tidak akan memberitahukan kode akses kepihak manapun</h5>

                        <template #modal-footer>
                            <button class="btn-primer" @click="registerKyc">
                                <div v-show="loading == false">Submit</div>
                                <b-spinner variant="light" v-show="loading" />
                            </button>
                        </template>
                    </b-modal>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import HeadRegister from "./component/HeadRegister.vue";
import axios from "axios";
import DisclosureStatement from "@/assets/filedownload/DisclosureStatement.vue";
export default {
    components: {
        HeadRegister,
        DisclosureStatement,
    },
    data() {
        return {
            currentDate: "",
            loading: false,
            statementTrading: Boolean,
            statementCode: Boolean,
            message: "",
            identityAddress: "",
            idCustomer: "",
            disclosure_completeness: false,
            form: {
                has_set_trading_simulation: "",
                has_confirm_costumer: "",
                has_investment_experience: "",
                has_set_company_profile: "",
                has_set_investment_experience: "",
                has_set_mandate: "",
                has_set_risk: "",
                has_set_trading_rules: "",
                step: "verification",
                completeness_verification: "",
                disclosure_customer: "",
                disclosure_risk: "",
                disclosure_mandate: "",
            },
            dataPrint: {
                fullname: "",
                alamat: "",
                telepone: "",
                ktp: "",
                pekerjaan: "",
                tandaTangan: null,
                noKantor: "",
                company_id: "",
                namaPejabat: "",
                jabatan: "",
                jabatanNasabah: "",
                no_ac_demo: "",
                tempat_ttd: "",
                complement: "",
                tanggalLahir: "",
                tempat_lahir: "",
                platform: [],
            },
        };
    },
    computed: {
        customerId() {
            return this.$store.getters.customerData._id;
        },
    },
    methods: {
        openModal() {
            if (this.form.completeness_verification && this.disclosure_completeness) {
                this.$refs["modal-statement"].show();
            } else {
                this.$toast.error("Statement Menerima belum disetujui");
            }
        },
        checkStatement(event) {
            this.disclosure_completeness = event;
        },
        registerKyc() {
            this.loading = true;
            if (this.disclosure_completeness && this.form.completeness_verification) {
                axios
                    .patch("/v2/kyc/submission/" + this.customerId)
                    .then((res) => {
                        let status = res.data.data.status_code;
                        if (status == "00") {
                            this.$router.push("/register-waiting");
                            this.loading = false;
                        } else if (status == "2005") {
                            this.isLoading = false;
                            this.$notify({
                                group: "foo",
                                title: "<h5>Silahkan lengkapi Data Pribadi</h5>",
                                type: "error",
                                duration: 2000,
                            });
                        } else if (status == "2006") {
                            this.isLoading = false;
                            this.$notify({
                                group: "foo",
                                title: "<h5>Silahkan lengkapi Data Pekerjaan</h5>",
                                type: "error",
                                duration: 2000,
                            });
                        } else if (status == "2007") {
                            this.isLoading = false;
                            this.$notify({
                                group: "foo",
                                title: "<h5>Silahkan lengkapi Data Keuangan</h5>",
                                type: "error",
                                duration: 2000,
                            });
                        } else if (status == "2008") {
                            this.isLoading = false;
                            this.$notify({
                                group: "foo",
                                title: "<h5>Silahkan lengkapi Data Kontak Darurat</h5>",
                                type: "error",
                                duration: 2000,
                            });
                        } else if (status == "2009") {
                            this.isLoading = false;
                            this.$notify({
                                group: "foo",
                                title: "<h5>Silahkan lengkapi Data Lampiran</h5>",
                                type: "error",
                                duration: 2000,
                            });
                        } else {
                            this.$notify({
                                group: "foo",
                                title: "<h5>kesalahan sistem</h5>",
                                type: "error",
                                duration: 2000,
                            });
                        }
                    })
                    .catch((error) => {
                        this.message = error.response.status;
                        this.loading = false;
                    });
            } else {
                this.$toast.error("Statement Menerima belum disetujui");
                this.loading = false;
            }
        },
        CheckStatement() {
            if (this.statementCode == true && this.statementTrading == true) {
                // this.$router.push("/register-preview");
                this.form.has_set_trading_rules = true;
                let methode;
                if (this.idCustomer) {
                    methode = {
                        url: "/v2/kyc/customer/" + this.idCustomer,
                        method: "PUT",
                        data: this.form,
                    };
                } else {
                    methode = {
                        url: "/v2/kyc/customer",
                        method: "POST",
                        data: this.form,
                    };
                }
                if (this.form.has_set_trading_rules) {
                    axios(methode)
                        .then((res) => {
                            let status = res.data.data.status_code;
                            if (status == "00") {
                                this.isLoading = false;
                                this.$router.push("/register-preview");
                            }
                        })
                        .catch((error) => {
                            this.isLoading = false;
                            console.log(error);
                            this.$notify({
                                group: "foo",
                                title: "Cek kembali inputan anda",
                                type: "error",
                                duration: 2000,
                            });
                        });
                }
            } else {
                this.$toast.error("Statement Menerima belum disetujui");
                this.isLoading = false;
                // this.message = "Mohon untuk menyutujui pernyataan ya / tidak";
            }
        },
    },
    mounted() {
        axios.get("/v2/user/profile").then((res) => {
            this.dataPrint.platform = res.data.data.user.platform;
        });
        this.currentDate = new Date();
        this.$store.dispatch("getCustomer").then((res) => {
            this.form.has_set_investment_experience = res.has_set_investment_experience;
            this.form.has_set_trading_simulation = res.has_set_trading_simulation;
            this.form.has_confirm_costumer = res.has_confirm_costumer;
            this.form.has_set_company_profile = res.has_set_company_profile;
            this.form.has_set_mandate = res.has_set_mandate;
            this.form.has_set_risk = res.has_set_risk;
            this.form.has_set_trading_rules = res.has_set_trading_rules;
            this.form.completeness_verification = res.completeness_verification;
            this.form.disclosure_customer = res.disclosure_customer;
            this.form.disclosure_risk = res.disclosure_risk;
            this.form.disclosure_mandate = res.disclosure_mandate;

            if (this.form.completeness_verification) {
                this.disclosure_completeness = true;
            }

            this.idCustomer = res._id;
            let dataAddress = res.identity_address;
            this.identityAddress = dataAddress;
            this.dataPrint.fullname = res.fullname;
            this.dataPrint.ktp = res.ktp_no;
            this.dataPrint.telepone = res.phonenumber;
            this.dataPrint.tempat_ttd = res.identity_address.regency;
            this.dataPrint.tanggalLahir = res.date_of_birth;
            this.dataPrint.tempat_lahir = res.place_of_birth;
            this.dataPrint.alamat =
                dataAddress.address + ", Kel. " + dataAddress.village + ", Kec. " + dataAddress.district + " " + dataAddress.regency + " " + dataAddress.province;

            axios.get("/v2/kyc/employment/" + res._id).then((resEmploy) => {
                this.dataPrint.pekerjaan = resEmploy.data.data.employment.occupation_type.name;
                this.dataPrint.jabatanNasabah = resEmploy.data.data.employment.other_position;
                this.dataPrint.noKantor = resEmploy.data.data.employment.company_address.telephone;
            });

            axios.get("/v2/kyc/attachment/" + res._id).then((resAttac) => {
                let attachment = resAttac.data.data.attachment;
                this.$store.dispatch("getImageAccess", attachment.signature).then((resImg) => {
                    this.dataPrint.tandaTangan = resImg;
                });
            });
        });
    },
};
</script>

<style scoped>
label {
    width: 12rem;
}

.container-outline {
    width: 70%;
}

.content-register {
    box-shadow: 0 0 2rem 0 rgba(136, 152, 170, 0.15);
    background: #ffffff;
    border-radius: 5px;
}

.button {
    display: flex;
    justify-content: space-between;
    padding: 76px 63px;
}

.register {
    margin: 46px 0;
}

.container {
    width: 100%;
}

.page {
    padding: 1cm;
    height: 257mm;
}

.wrap-document {
    min-height: 297mm;
    padding: 10mm;
    margin: 0 auto;
    border-radius: 5px;
    background: white;
    position: relative;
}

.wrap-radio-input {
    display: flex;
    gap: 1rem;
}

.radio-input {
    display: flex;
    align-items: baseline;
}

.title {
    font-weight: bold;
    text-align: center;
    margin: 0 auto 40px;
    font-size: 14px;
}

.title-page {
    font-size: 25px;
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    margin: 0 0 50px;
}

.wrap-content {
    padding: 3rem 2rem;
}

.content {
    font-size: 14px;
}

.content-item {
    display: flex;
    gap: 3rem;
    line-height: 2;
    margin-bottom: 0.5rem;
}

.content-item div:first-child {
    flex: 2;
}

.content-item div:last-child {
    flex: 1;
    font-weight: bold;
}

.label-radio {
    width: 3rem;
    margin-left: 0.6rem;
}

.penutup {
    font-weight: normal;
    font-size: 14px;
    margin-bottom: 2rem;
}

.content-penutup {
    width: 80%;
    text-align: center;
    margin: 1rem auto;
}

.title-penutup {
    font-weight: bold;
    font-size: 16px;
    text-align: center;
}

.wrap-pernyataan {
    width: 70%;
    margin: 0 auto;
}

.pernyataan {
    display: flex;
    padding: 0 1rem;
    margin-top: 1rem;
    gap: 1rem;
}

.pernyataan:last-child {
    margin-top: unset;
}

.label {
    width: 20rem;
}

@media (max-width: 768px) {
    .page {
        padding: 0;
    }

    .wrap-content {
        padding: unset;
    }

    .title {
        margin: 20px auto !important;
    }
    .container-outline {
        width: 90%;
    }

    li > span {
        display: none;
    }

    .form-input,
    select,
    .input-button {
        width: 100%;
    }

    .birtday,
    .kecamatan,
    .input-rt-rw {
        width: 100% !important;
        text-align: left;
    }

    .register {
        margin: 20px 0;
    }

    .title {
        font-size: 18px;
        margin: 0 0 20px;
    }

    .sub-title {
        margin-bottom: 20px;
    }

    .top-squence {
        width: 100%;
        padding: 15px 10px;
    }

    .container {
        width: 100%;
        padding: 25px 20px;
    }

    .identitas,
    .form-ktp-bagi,
    .tanggal-aktif,
    .tempat,
    .kecamatan,
    .input-rt-rw {
        margin: 0 0 10px;
    }

    .detail-alamat,
    .rt-rw {
        margin: 0 0 0.5rem;
    }

    .form-checkbox {
        align-items: flex-start;
    }

    .label--checkbox {
        position: inherit !important;
        margin-left: 15px;
    }

    label {
        display: block;
    }

    .button {
        display: block;
        width: 100%;
        padding: 25px 20px;
        text-align: center;
    }

    .btn-scondary,
    .btn-primer {
        width: 100%;
    }

    .btn-scondary {
        margin-bottom: 20px;
    }

    .content-modal {
        width: 95%;
    }

    .wrap-document {
        width: 100%;
        padding: 30px 0;
    }

    .content-penutup,
    .wrap-pernyataan {
        width: 100%;
        font-size: 13px;
    }

    .label {
        width: 10rem;
    }
}
</style>
